import { render } from "./NuevaEntradaComponent.vue?vue&type=template&id=607c310b&scoped=true"
import script from "./NuevaEntradaComponent.vue?vue&type=script&lang=js"
export * from "./NuevaEntradaComponent.vue?vue&type=script&lang=js"

import "./NuevaEntradaComponent.vue?vue&type=style&index=0&id=607c310b&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607c310b"]])

export default __exports__